export const sanitizeInternalRedirect = (
  target: string | null | undefined,
  baseOrigin?: string,
): string | null => {
  if (!target) {
    return null
  }

  const trimmed = target.trim()
  if (!trimmed) {
    return null
  }

  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) {
    return null
  }

  try {
    const origin =
      baseOrigin ||
      (typeof window !== 'undefined'
        ? window.location.origin
        : 'http://localhost')
    const parsed = new URL(trimmed, origin)

    if (parsed.origin !== origin) {
      return null
    }

    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return null
  }
}
